import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
import { leaveProcess } from "@/api/work/process";
export default {
  data: function data() {
    return {
      form: {},
      option: {
        group: [{
          icon: 'el-icon-info',
          label: '请假基础信息',
          prop: 'group1',
          column: [{
            label: '审批人员',
            prop: 'taskUser',
            type: 'select',
            dicUrl: "/api/blade-user/user-list",
            props: {
              label: "account",
              value: "id"
            },
            span: 24,
            rules: [{
              required: true,
              message: '请选择审批人员',
              trigger: 'blur'
            }]
          }, {
            label: '开始时间',
            prop: 'startTime',
            type: 'datetime',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: [{
              required: true,
              message: '请选择开始时间',
              trigger: 'blur'
            }]
          }, {
            label: '结束时间',
            prop: 'endTime',
            type: 'datetime',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: [{
              required: true,
              message: '请选择结束时间',
              trigger: 'blur'
            }]
          }, {
            label: '请假理由',
            prop: 'reason',
            type: 'textarea',
            span: 24,
            rules: [{
              required: true,
              message: '请输入请假理由',
              trigger: 'blur'
            }]
          }]
        }]
      }
    };
  },
  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      var params = _objectSpread({
        processDefinitionId: this.$route.params.processDefinitionId
      }, this.form);

      leaveProcess(params).then(function (resp) {
        var data = resp.data;

        if (data.success) {
          _this.$message.success(data.msg);

          _this.$router.$avueRouter.closeTag();

          _this.$router.push({
            path: "/work/start"
          });
        } else {
          _this.$message.error(data.msg || '提交失败');
        }
      });
    }
  }
};